<div style="display: flex;flex-direction: column;height: 100vh">
  <app-navigation style="position:sticky;top:0;z-index: 1000"></app-navigation>

  <router-outlet></router-outlet>

  <kendo-appbar class="bottom-appbar showInDesktop" [position]="'bottom'" [themeColor]="'dark'" style="background-color: #d3d3d3;position:fixed;width: 100%">
    <kendo-appbar-spacer [width]="'78%'"></kendo-appbar-spacer>
    <kendo-appbar-section>
      <div class="need-help links text-center">
        Need Help? please log a ticket on  <a target= "__blank" class="signin" href="https://tke.service-now.com">ServiceNow</a>
      </div>
    </kendo-appbar-section>
  </kendo-appbar>
</div>

